import React from "react";
import styled, { css } from "styled-components";
import Section from "./Section";
import { HtmlContent } from "./Content";

const ThreeDEmbdedStyles = styled.div`
  ${({ ...props }) => css`
    iframe {
      width: 100%;
      max-width: ${props.$fullWidth ? '100%' : '1000px'};
      margin: 0 auto;
      display: block;
      border-radius: ${props.$fullWidth ? '0' : '4px'};
      overflow: hidden;
      aspect-ratio: 16/9;
      max-height: 70vh;
    }
    @media (min-width: ${props.theme.breakpoints.lg}) {
      iframe {
        height: ${props.$fullWidth ? '100%' : '500px'};
      }
    }
  `}
`;

export const ThreeDView = ({ threeDViewEmbed, fullWidth = false }) => {
  return (
    <Section heading="3D View">
      <ThreeDEmbdedStyles
        $fullWidth={fullWidth}
      >
        <HtmlContent
          htmlString={
            /* Hack to add lazy loading to iframes - it should really be done with a HTML parser, or manually in WordPress */
            threeDViewEmbed.replaceAll('allowfullscreen', 'allowfullscreen loading="lazy"')
          }
        />
      </ThreeDEmbdedStyles>
    </Section>
  );
};
